import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
  DivToolTip,
} from "@utils/extra-style";

const Transports = (props) => {
  const { t, data } = props;
  const tooltipId = `transport-tooltip-${data.id}`;
  const tooltipAnchor = `#transport-tooltip-${data.id}`;
  const countText = data?.count > 0 ? ` (+${data?.count})` : "";
  return (
    <>
      {data.isActive == 1 && (
        <DivBackgroundFullOpacity>
          <span id={tooltipId}>
            {t(data?.name)}
            {countText}
          </span>
          <Tooltip
            anchorSelect={tooltipAnchor}
            style={DivToolTip}
            content={t(data?.completeName)}
          />
        </DivBackgroundFullOpacity>
      )}
      {data.isActive == 0 && (
        <DivBackgroundLowOpacity>
          <span id={tooltipId}>
            {t(data?.name)}
            {countText}
          </span>
          <Tooltip
            anchorSelect={tooltipAnchor}
            style={DivToolTip}
            content={t(data.completeName)}
          />
        </DivBackgroundLowOpacity>
      )}
    </>
  );
};

Transports.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Transports);
